import { createSlice } from "@reduxjs/toolkit";
import {
  fetchWarehouseDispatch
} from "./thunk";

interface DispatchState {
  // List state
  list: any[];
  count: number;
  loading: boolean;
  error: string | null;

}

const initialState: DispatchState = {
  list: [],
  count: 0,
  loading: false,
  error: null,
  
};

const WarehouseDispatchSlice = createSlice({
  name: "Dispatch",
  initialState,
  reducers: {
    resetDispatchState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // ✅ Fetch Dispatch List
      .addCase(fetchWarehouseDispatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseDispatch.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.count = action.payload.rowCount;
      })
      .addCase(fetchWarehouseDispatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch dispatch list";
      })      
  },
});

export const { resetDispatchState } = WarehouseDispatchSlice.actions;
export default WarehouseDispatchSlice.reducer;
